import { render, staticRenderFns } from "./publicexamLogin.vue?vue&type=template&id=2267e838&scoped=true"
import script from "./publicexamLogin.vue?vue&type=script&lang=js"
export * from "./publicexamLogin.vue?vue&type=script&lang=js"
import style0 from "./publicexamLogin.vue?vue&type=style&index=0&id=2267e838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2267e838",
  null
  
)

export default component.exports